import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { Hero } from "@/components/site/Hero";
import { PageShell } from "@/components/site/PageShell";
import { breadcrumbLd } from "@/lib/jsonld";
import { SITE } from "@/lib/site";

const crumbs = [{ label: "Impressum", to: "/impressum" }];

export default function ImpressumPage() {
  return (
    <>
      <Seo title="Impressum | Kfz-Sachverständiger Marcone Köln" description="Impressum des Kfz-Sachverständigenbüros Francesco Marcone, Neusser Str. 401–403, 50733 Köln – Partner der FSP Schaden- und Wertgutachterdienst GmbH." path="/impressum" jsonLd={[breadcrumbLd(crumbs)]} />
      <PageShell hero={<Hero image="hero-leasing" imageAlt="Fahrzeug in einem hellen Autohaus" title="Impressum" breadcrumbs={crumbs} badges={false} />}>
        <article className="legal-content" data-testid="impressum-content">
          <h2 style={{ marginTop: 0 }}>Angaben gemäß § 5 DDG</h2>
          <p data-testid="impressum-provider">
            {SITE.company}<br />
            Kfz-Sachverständigenbüro Marcone<br />
            {SITE.owner}<br />
            {SITE.street}<br />
            {SITE.zip} {SITE.city}<br />
            Deutschland
          </p>

          <h2>Kontakt</h2>
          <p>
            Telefon: <a href={SITE.phoneHref}>{SITE.phoneIntl}</a><br />
            Mobil / WhatsApp: <a href={SITE.mobileHref}>{SITE.mobileIntl}</a><br />
            E-Mail: <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
          </p>

          <h2>Berufsbezeichnung</h2>
          <p>Kfz-Sachverständiger, Partner der {SITE.company} (TÜV Rheinland / FSP).</p>

          <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
          <p>{SITE.owner}, {SITE.street}, {SITE.zip} {SITE.city}</p>

          <h2>Verbraucherstreitbeilegung</h2>
          <p>Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

          <h2>Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Die Inhalte wurden mit größter Sorgfalt erstellt;
            für Richtigkeit, Vollständigkeit und Aktualität können wir jedoch keine Gewähr übernehmen. Die Informationen auf dieser Website sind allgemeiner Natur und ersetzen
            keine individuelle Rechtsberatung. Wir sind nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen. Sobald uns eine konkrete
            Rechtsverletzung bekannt wird, entfernen wir die betreffenden Inhalte umgehend.
          </p>

          <h2>Haftung für Links</h2>
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte ist stets der jeweilige Anbieter
            oder Betreiber verantwortlich. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Bei Bekanntwerden von Rechtsverletzungen entfernen wir
            derartige Links umgehend.
          </p>

          <h2>Urheberrecht</h2>
          <p>
            Die Inhalte und Werke auf dieser Website (Texte, Fotos, Grafiken) unterliegen dem deutschen Urheberrecht. Vervielfältigung, Bearbeitung, Verbreitung und jede Art
            der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Rechteinhabers. Sollten Sie auf eine
            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen Hinweis – wir entfernen den Inhalt dann umgehend.
          </p>

          <h2>Bildquellen</h2>
          <p data-testid="impressum-image-credits">Fotos: Kfz-Sachverständigenbüro Marcone, teilweise Symbolbilder.</p>
          <p>Logo: TÜV Rheinland / FSP – Verwendung als Partner der {SITE.company}.</p>

          <h2>Datenschutz</h2>
          <p>
            Informationen zur Verarbeitung Ihrer Daten finden Sie in unserer{" "}
            <Link to="/datenschutz" data-testid="impressum-privacy-link">Datenschutzerklärung</Link>.
          </p>
        </article>
      </PageShell>
    </>
  );
}
